// const API_UPDATE_METAFILDS_UPLOAD = 'https://dddemo.net/php/2025/vijay/dress-and-safe/update_metafield.php';
const API_UPDATE_METAFILDS_UPLOAD = 'https://shopify.dress-and-safe.de/metafieldsupdate/update_metafield.php';
const API_UPDATE_FILE_UPLOAD = 'https://shopify.dress-and-safe.de/metafieldsupdate/Filerupload.php';

function people_data_upload(params,metfilds_key,checkrefreask = false) {
 
 
  if(!customer_ID) return
 
  console.log(params);
const formdata = new FormData();
formdata.append("customer_id", customer_ID);
formdata.append("type", "json");
formdata.append("json", JSON.stringify(params));
formdata.append("namespace", "custom");
formdata.append("key", metfilds_key);

const requestOptions = {
  method: "POST",
  body: formdata,
  redirect: "follow"
};


fetch(API_UPDATE_METAFILDS_UPLOAD, requestOptions)
  .then((response) => response.json())
  // .then((result) => console.log(result))
    .then((result) => {
         if(checkrefreask){
          window.location.reload();
         }
      if (result.success == true) {
        if (document.body.classList.contains('template-people')) {
          document.body.classList.add('new-people-success-popup-show');
          document.querySelectorAll('.new-people-sucess-text').forEach(el => {
            el.classList.add('active');
          });
        }
      }
      
         // reloadManagePeopleSection();
    
  })
  .catch((error) => console.error(error));


//   const formdata = new FormData();
// formdata.append("customer_id", "8841806971218");
// formdata.append("json", "{ \"lon\": 139.01, \"lat\": 35.02 }");
// formdata.append("namespace", "custom");
// formdata.append("type", "json");
// formdata.append("key", "customer_cart");

// const requestOptions = {
//   method: "POST",
//   body: formdata,
//   redirect: "follow"
// };

// fetch("https://shopify.dress-and-safe.de/metafieldsupdate/update_metafield.php", requestOptions)
//   .then((response) => response.text())
//   .then((result) => console.log(result))
//   .catch((error) => console.error(error));

  
}


function people_data_upload_edit(params,metfilds_key,checkrefreask = false) {

 
  if(!customer_ID) return
 
  console.log(params);
const formdata = new FormData();
formdata.append("customer_id", customer_ID);
formdata.append("type", "json");
formdata.append("json", JSON.stringify(params));
formdata.append("namespace", "custom");
formdata.append("key", metfilds_key);

const requestOptions = {
  method: "POST",
  body: formdata,
  redirect: "follow"
};

fetch(API_UPDATE_METAFILDS_UPLOAD, requestOptions)
  .then((response) => response.json())
  // .then((result) => console.log(result))
    .then((result) => {
         if(checkrefreask){
          window.location.reload();
         }
      if (result.success == true) {
        window.location.reload();
      }
      
         // reloadManagePeopleSection();
    
  })
  .catch((error) => console.error(error));
  
}



function reloadManagePeopleSection() {

    var url = ''.concat(routes.root, '?t=').concat(Date.now());
  
      url = url.indexOf('?') === -1 ? (url + '?section_id=manage-people') : (url + '&section_id=manage-people');
    console.log(url)
    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newContent = doc.querySelector('#manage-people');
        if (newContent) {
          document.getElementById('manage-people').innerHTML = newContent.innerHTML;
        }
        const back_button = document.querySelector("[back-btn='people']") || null;
          if(!back_button) return;
          back_button.click();
      })
      .catch((error) => {
        console.error('Failed to reload section:', error);
      });
  }


function file_upload_PHP(file,input,preview_image,loading_image){
  const input_set = input;

  const time_stamp = new Date().getTime();
  
  if(!input_set) return;
  
  const formdata = new FormData();
  console.log("file.name",file.name,file)
  
  formdata.append("file", file, file.name );
  
  const requestOptions = {
    method: "POST",
    body: formdata,
    redirect: "follow"
  };

  fetch(API_UPDATE_FILE_UPLOAD, requestOptions)
  .then((response) => response.json())
  .then((result) => {
    // console.log("result",result);
    if(!result.success){
      if(loading_image){
      loading_image.classList.add('hidden');
       alert(result.message);
        return; 
    }
    } 
    input_set.value = result.url;
    
    if (!preview_image){
      const preview = document.querySelector('[preview_image]');
        if (preview) {      
          preview.src = result.url;
        }
    }else{
      preview_image.src = result.url
    }
    if(loading_image){
      loading_image.classList.add('hidden');
    }
    // if (document.querySelector('[svg_hidden]')) {
    //   document.querySelector('[svg_hidden]').classList.add('hidden');
    // }
  })
  .catch((error) => console.error(error));  
}


(function() {
  const filted_upload_check =  document.querySelectorAll('[data-filed-upload]') || null;
    if(filted_upload_check){
      filted_upload_check.forEach(item => {
            item.addEventListener('change', (e) => {
              // if (e.target.closest('form').querySelector('[loading_hidden]')) {
              //   e.target.closest('form').querySelector('[loading_hidden]').classList.remove('hidden');
              // }      
               const filted_upload_check_input =  e.target.closest('form').querySelector('[uploaded_profile_url]') || e.target;
               const preview =  e.target.closest('form').querySelector('[preview_image]') || null;   
               const loading_image = e.target.closest('form').querySelector('[loading_hidden]') || null
               if (loading_image) {
                loading_image.classList.remove('hidden');
              }        
              const file = e.target.files[0];
              // var extension = files[0].type;
              console.log("file",file,filted_upload_check_input,preview,loading_image);
              // console.log("e.target",e.target)
              file_upload_PHP(file,filted_upload_check_input,preview, loading_image);
           });
        });
    } 
  
})();
